import { render, staticRenderFns } from "./thankBox.vue?vue&type=template&id=81a199fc&scoped=true"
import script from "./thankBox.vue?vue&type=script&lang=js"
export * from "./thankBox.vue?vue&type=script&lang=js"
import style0 from "./thankBox.vue?vue&type=style&index=0&id=81a199fc&prod&lang=scss"
import style1 from "./thankBox.vue?vue&type=style&index=1&id=81a199fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a199fc",
  null
  
)

export default component.exports